export const BUSINESS_INFO_TEST_ID = {
  root: 'business-info',
  name: 'business-name',
  address: 'business-address',
  phoneNumber: 'business-phone-number'

};
